import React from 'react'
import styled, { css } from 'styled-components'
import { IconName } from './IconName'

export type IconProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & {
  name: IconName
  size?: number
  color?: string
}

// <React.FC<IconProps>>(({ name, className, ...props }) => {
//   return <span {...props} className={`glyphicons glyphicons-${name}` + (className ? ' ' + className : '')} />
// })

const Icon = styled.span.attrs<IconProps>(({ name }) => ({
  className: `glyphicons glyphicons-${name}`
}))<IconProps>`
  ${({ size }) =>
    typeof size === 'undefined'
      ? undefined
      : css`
          font-size: ${size}px;
        `}
  ${({ color }) =>
    typeof color === 'undefined'
      ? undefined
      : css`
          color: ${color};
        `}
`

export default Icon
